import { y, x, width, height } from './accessors.js';
import { BarCanvas } from '../../../core/components/canvas/components/BarCanvas.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { DEFAULT_FILL_OPACITY } from '../../../core/constants.js';
import { useHistogramFilteredData } from '../../hooks/useHistogramFilteredData.js';
import { useHistogramYScales } from '../../hooks/useHistogramYScales.js';
import { safeGet } from '../../providers/HistogramDataProvider.js';
import { HistogramSeries, XScale } from '../../types/histogram.js';

interface BarChartDisplayProps {
  xScale: XScale;
  series: HistogramSeries[];
}

export function BarChartDisplay({
  xScale,
  series,
}: Readonly<BarChartDisplayProps>) {
  const yScales = useHistogramYScales();
  const { width: widthPlot, height: heightPlot } = useGridPlotSize();
  const { seriesMap, binsMap } = useHistogramFilteredData();

  return (
    <div data-testid="histogram-bar-chart-display">
      {series.map((singleSeries) => {
        const seriesMetadata = safeGet(seriesMap, singleSeries);

        const yScale = yScales[seriesMetadata.scaleIndex];

        return (
          <BarCanvas
            key={seriesMetadata.id}
            data={singleSeries.bins}
            canvasWidth={widthPlot}
            canvasHeight={heightPlot}
            x={x(xScale, binsMap)}
            y={y(yScale, binsMap)}
            width={width(xScale, binsMap)}
            height={height(yScale, binsMap)}
            strokeWidth={1}
            color={() => seriesMetadata.color.Default}
            opacity={() => DEFAULT_FILL_OPACITY}
          />
        );
      })}
    </div>
  );
}
